import axios from '../../shared/axiosConfig';
import { push } from 'connected-react-router'
import * as AppActions from './App';

export const JobsActions = {
  SET_ATTRIBUTE: "JOBS_SET_ATTRIBUTE",
  RESET_STATE: "JOBS_RESET_STATE"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setJobsAttribute = (key, value) => {
  return {
    type: JobsActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const companiesResetState = () => {
  return {
    type: JobsActions.RESET_STATE
  }
}

export const openJob = (jobId) => (dispatch) => {
  dispatch( setJobsAttribute( 'currentJobId', jobId ) );
}

export const closeJob = () => (dispatch) => {
  dispatch( setJobsAttribute( 'currentJobId', null ) );
}

export const loadJobs = (eventId, companyId) => async (dispatch) => {
  dispatch( AppActions.setLoading(true) );
  dispatch( setJobsAttribute('loading', true ) );
  await axios.get(`/api/events/${eventId}/companies/${companyId}/jobs`)
    .then(async (response) => {
      console.log("Got jobs", response);
      dispatch( AppActions.setLoading(false) );
      dispatch( setJobsAttribute('loading', false ) );
      dispatch( setJobsAttribute('loaded', true ) );
      dispatch( setJobsAttribute('items', response.data ) );
    })
    .catch((error) => {
      console.log("Error getting token", error);
      dispatch( AppActions.setLoading(false) );
      dispatch( setJobsAttribute('loading', false ) );
      dispatch( setJobsAttribute('errors', error ) );
      // TODO: put app-wide error here
    });
}
